module.exports = __webpack_public_path__ + "img/version_img6.a0f6df6e.png";